<template>
    <section>
        <div class="row">
            <div class="col-lg-12 col-xl-7">
                <store-info @saveData="saveData($event)" :fieldData="fieldData"></store-info>
            </div>
            <div class="col-lg-12 col-xl-5">
                <store-google-map @saveData="saveData($event)" :fieldData="fieldData"></store-google-map>
            </div>
        </div>

        <div class="row">
            <div class="col-12">
                <store-open-time @saveData="saveData($event)" :fieldData="fieldData"></store-open-time>
            </div>
        </div>

        <div class="row">
            <div class="col-12">
                <store-remark @saveData="saveData($event)" :fieldData="fieldData"></store-remark>
            </div>
        </div>

        <div class="row">
            <div class="col-12">
                <store-picture @saveData="saveData($event)" :fieldData="fieldData"></store-picture>
            </div>
        </div>

        <div class="row">
            <div class="col-12">
                <store-staff></store-staff>
            </div>
        </div>

        <div class="row">
            <div class="col-12">
                <store-branch></store-branch>
            </div>
        </div>
    </section>    
</template>

<script>
import StoreInfo from '@/components/store/StoreInfo';
import StoreGoogleMap from '@/components/store/GoogleMap';
import StoreOpenTime from '@/components/store/OpenTime';
import StoreRemark from '@/components/store/Remark';
import StorePicture from '@/components/store/Picture';
import StoreStaff from '@/components/store/StoreStaff';
import StoreBranch from '@/components/store/StoreBranch';
import DBStore from '@/database/Store';

export default {
    components: { 
        StoreInfo,
        StoreGoogleMap,
        StoreOpenTime,
        StoreRemark,
        StorePicture,
        StoreStaff,
        StoreBranch
    },
    data() {
        return {
            fieldData: {}
        }
    },
    mounted() {
        this.loadFieldData();
    },
    methods: {
        async loadFieldData() {
            const loader = this.$AppUtility.renderLoadBackdrop();
            const data = await DBStore.get();

            if (data) {
                this.fieldData = data.content;
            }

            loader.hide();
        },
        async saveData(value) {
            const loader = this.$AppUtility.renderLoadBackdrop();
            this.fieldData[value.group] = value.data[value.group];

            const param = {
                value: this.fieldData[value.group],
                group: value.group
            };
            
            await DBStore.save(param);

            loader.hide();
        }
    }
}
</script>